import Typography from "@/components/_Atoms/_NewComponents/Typography";
import { IconV2, Tooltip } from "@abtasty/design-system";
import { isEmpty } from "lodash";
import "./styles.css";
import { CardLabelProps } from "./types";

const CardLabel = ({ label, help }: CardLabelProps) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <Typography variant="body-strong">{label}</Typography>
      {!isEmpty(help) && (
        <div className="tooltip">
          <Tooltip content={help} placement="top">
            <IconV2
              icon={"info"}
              size={16}
              color="var(--primary-default-fg-subtitle)"
            />
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default CardLabel;
